import React, { createContext, useState, useContext, useEffect } from "react";
import { getUserDetails } from "../services/auth.service";
import Cookies from 'js-cookie';

// Create context
const UserContext = createContext();

// Context provider
export const UserContextProvider = ({ children }) => {
  // State for user data
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  
  // State for cart data
  const [cart, setCart] = useState([]);

  useEffect(() => {
    if(isAuthenticated){
      getUserDetails().then((res) => {
        setUser(res.data);
      }).catch((e) => {
        console.log(e);
      })
    }
  }, [isAuthenticated])

  useEffect(() => {
    const token = Cookies.get('token');
    if (token) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, []);

  const login = (token) => {
    Cookies.set('token', token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    Cookies.remove('token');
    setIsAuthenticated(false);
  };

  // Example: Function to add item to cart
  const addToCart = (item) => setCart([...cart, item]);

  // Example: Function to remove item from cart
  const removeFromCart = (itemId) => setCart(cart.filter(item => item.id !== itemId));

  return (
    <UserContext.Provider value={{ user, login, logout, cart, addToCart, removeFromCart, isAuthenticated }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use context
export const useUserContext = () => {
  return useContext(UserContext);
};
